import React, { useState, useRef, useEffect } from "react";
import styles from "./decimal.module.css";
import { TextField } from "@mui/material";
import ElementTitle from "ui/crfs/element_title";
import DividerLine from "ui/crfs/divider_line";
import DecimalUI from "./components/decimal_ui";
import DataCompleteChangeModal from "ui/crfs/data_complete_change_modal";
import EntryRuleOverrideModal from "ui/crfs/entry_rule_override_modal";
import ElementMenu from "ui/crfs/element_menu";
import LoadingButton from "@mui/lab/LoadingButton";

let tempStorage = null;

export default function Decimal(props) {
  const {
    field,
    field_id,
    title,
    onUpdate,
    enableQuery,
    length,
    placeHolder,
    read_only,
    crfStatus,
    toggleHistory,
    selected_audit_icon,
    setQueryModalData,
    captureCompleteDateChangeReason = false,
  } = props;

  const [showingCompleteChangeModal, setShowingCompleteChangeModal] = useState(false);
  const [showingEntryOverrideModal, setShowingEntryOverrideModal] = useState(false);
  const [dataChange, setDataChange] = useState(false);
  const [localVal, setLocalVal] = useState(field.value_obj?.value || "");

  useEffect(() => {
    tempStorage = field.value_obj.value;
  }, [field.value_obj.value]);

  const acceptTempStorage = (reason) => {
    commonUpdateValueActions(localVal, reason);
    tempStorage = localVal;
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setDataChange(false);
  };
  const closeModal = () => {
    setShowingCompleteChangeModal(false);
    setShowingEntryOverrideModal(false);
    setLocalVal(tempStorage);
    setDataChange(false);
  };

  const commonUpdateValueActions = (value, reason = null) => {
    if (value === tempStorage) {
      return;
    }
    onUpdate({
      data_id: field?.value_obj?.data_id || null,
      flags: field?.value_obj?.flags || null,
      value,
      value_name: field.value_name,
      reason,
    });
  };

  const updateValue = (error_override = false) => {
    if (crfStatus === "data_complete" && captureCompleteDateChangeReason) {
      setShowingCompleteChangeModal(true);
      return;
    } else if (entry_rule_error() && !error_override) {
      if (field.entry_rule_override) {
        setShowingEntryOverrideModal(true);
      } else {
        setLocalVal(tempStorage);
        setDataChange(false);
      }
      return;
    } else {
      commonUpdateValueActions(localVal);
      setDataChange(false);
    }
  };

  const onChange = (value) => {
    if (!dataChange) {
      tempStorage = field.value_obj?.value || "";
    }
    setDataChange(true);
    setLocalVal(value);
  };

  const entry_rule_error = () => {
    let error = false;
    if (localVal?.length > 0 && field.entry_rules && dataChange) {
      field.entry_rules.some((rule) => {
        if (rule.rule_type === "min") {
          if (parseFloat(localVal) < parseFloat(rule.value)) {
            error = `Must be greater than or equal to ${rule.value}`;
            return error;
          }
        } else if (rule.rule_type === "max") {
          if (parseFloat(localVal) > parseFloat(rule.value)) {
            error = `Must be less than or equal to ${rule.value}`;
            return error;
          }
        }
      });
    }
    return error;
  };

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles.left_split}>
          {enableQuery ? (
            <div>
              <ElementTitle required={field.required} title={title} />
            </div>
          ) : (
            <div>{title}</div>
          )}
        </div>

        <div className={styles.right_split}>
          {read_only || field.read_only ? (
            <React.Fragment>
              <div>
                {field.value_obj.value || "--"} {field.units}
                {field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}
              </div>
              <div className={styles.audit_icon}>
                <ElementMenu {...props} read_only={read_only || field.read_only} />
              </div>
            </React.Fragment>
          ) : (
            <div className={styles.flex_column}>
              <div className={styles.flex_row}>
                <DecimalUI
                  {...props}
                  value={localVal}
                  onChange={onChange}
                  onUpdate={updateValue}
                  units={(field && field.units) || ""}
                  error={dataChange && entry_rule_error()}
                />

                <div className={styles.audit_icon}>
                  <ElementMenu {...props} />
                </div>
              </div>
              {field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}
              <div className={styles.flex_row}>
                {entry_rule_error().constructor === String ? (
                  <div className={styles.input_flex}>
                    <div className={styles.error}>{entry_rule_error()}</div>{" "}
                    {field.entry_rule_override ? (
                      <LoadingButton
                        variant="outlined"
                        loading={false}
                        onClick={() => updateValue(true)}
                        sx={{
                          fontSize: 14,
                          padding: "2px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          marginLeft: "10px",
                        }}
                      >
                        Save Anyway
                      </LoadingButton>
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
      <DividerLine />
      <DataCompleteChangeModal isOpen={showingCompleteChangeModal} close={closeModal} onYes={acceptTempStorage} />
      <EntryRuleOverrideModal isOpen={showingEntryOverrideModal} close={closeModal} onYes={acceptTempStorage} />
    </div>
  );
}
